/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Brokers_MeInputs */

const cs_calendar_brokers_me = /** @type {(inputs: Calendar_Brokers_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jen já`)
};

const en_calendar_brokers_me = /** @type {(inputs: Calendar_Brokers_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only me`)
};

/**
* | output |
* | --- |
* | "Only me" |
*
* @param {Calendar_Brokers_MeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_brokers_me = /** @type {((inputs?: Calendar_Brokers_MeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Brokers_MeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_brokers_me(inputs)
	return cs_calendar_brokers_me(inputs)
});